// Boot-screen finish: the loading screen simply fades out and is removed. (It used to scale and fly the logo
// into the header; that transition was removed. The header's own 3D logo animation is independent of this.)
const sleep = (ms: number) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export async function finishBootScreen(bootLoader: HTMLElement, _options?: { expectHeaderLogo?: boolean }): Promise<void> {
  // The loading screen's own WebGL logo is no longer needed once it fades.
  const dispose = () => (bootLoader.querySelector('[data-logo3d="boot"]') as any)?.__logo3d?.dispose?.();
  bootLoader.style.transition = 'opacity 320ms ease, visibility 320ms ease';
  bootLoader.classList.add('is-hidden');
  await sleep(360);
  dispose();
}
